import axios from "axios";

const api = axios.create({
  baseURL: "https://deliciasdelpanadmin.com/api", // Your backend API URL
  //withCredentials: true, // Ensures cookies like sessionid are sent
});

export default api;